import { call, put, takeLatest } from 'redux-saga/effects';

import * as footerActions from './footerActions.js';
import { updateFooterApiCall } from './footerAPI.js';

function* updateFooterSaga({ payload }) {
  try {
    const { data } = yield call(updateFooterApiCall, payload);
    yield put(footerActions.footerUpdateStore(data));
  } catch (error) {
    yield put(footerActions.footerUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* footerWatcher() {
  yield takeLatest(footerActions.footerUpdateRequest.type, updateFooterSaga);
}
